import { Breadcrumb } from "antd";
import React from "react";
import { Panel, PanelBody, PanelHeader } from "../../../util/panel";
import { Link } from "react-router-dom";
import TrackingFilter from "./components/tracking-filter";
import TableBill from "./components/bill.table";

const TrackingList = () => {
  return (
    <>
      <Breadcrumb className="mb-2">
        <Breadcrumb.Item>
          <Link to="/">หน้าหลัก</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Store QR</Breadcrumb.Item>
        <Breadcrumb.Item>รายการใบเสร็จ</Breadcrumb.Item>
      </Breadcrumb>
      <Panel>
        <PanelHeader>รายการใบเสร็จ</PanelHeader>
        <PanelBody>
          <TrackingFilter />
          <TableBill />
        </PanelBody>
      </Panel>
    </>
  );
};

export default TrackingList;
